@if(!isProd){
  <section>
    <div [ngClass]="{'aviso-hml': !isMobile, 'aviso-hml-mobile': isMobile}" (click)="mostrarDetalhesPlataforma()">
    {{ avisoTexto }}
    </div>
  </section>
}

<mat-sidenav-container
  class="main-container"
  [style.height]="calcularHeightPagina()"
  [style.padding-bottom]="'0px'"
>
  <!-- [style.padding-bottom]="isMobile && estaLogado && !contatoSelecionado ? 'calc(60px + env(safe-area-inset-bottom, 0px))' : '0px'" -->

<!--  @if(!isMobile){-->
<!--    <mat-sidenav style="margin: 10px; border-radius: 10px;" disableClose mode="side" [fixedInViewport]="false" [opened]="estaLogado">-->
<!--      @if (estaLogado) {-->
<!--        <app-side-menu [isMobile]="false" (menuOpenChange)="onMenuOpenChange($event)"></app-side-menu>-->
<!--      }-->
<!--    </mat-sidenav>-->
<!--  }-->

  <mat-sidenav-content class="content-area">
    <div class="pagina">
      @if (titulo && titulo.length > 0){
        <div class="titulo-area">
          <app-titulo [titulo]="titulo"></app-titulo>
        </div>
      }

      <div class="conteudo-area">
        <router-outlet></router-outlet>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

<!-- @if(isMobile && estaLogado && !contatoSelecionado) {
  <mat-toolbar-row class="tool-bar" color="primary">
    <app-side-menu [openMenu]="isMenuOpen" [isMobile]="true" (menuOpenChange)="onMenuOpenChange($event)"></app-side-menu>
  </mat-toolbar-row>
} -->

